<template>
  <div class="d-flex align-items-center">
    <div class="container-fluid">
      <h2 class="text-center">{{ $t('message.trade.enterTradeInVehicle') }}</h2>
      <div class="autocomplete-container">
        <trade-auto-complete
          v-model="vehicleSelected"
          :valueObject="selectedVehicleObject"
          :label="$t('message.credit.application.tradeInVehicle.yearMakeModel')"
          :placeholder="$t('message.trade.autoFillPlaceHolder')"
          :hidden-label="true"
          @selectedVehicleObject="selectedTradeVehicle"
        >
        </trade-auto-complete>
      </div>
    </div>
  </div>
</template>

<script>
import TradeAutoComplete from '@/components/shared/TradeAutoComplete.vue';
import TradeInSource from '@/utils/enums/tradeInSource';

export default {
  name: 'VehicleSelection',
  components: { TradeAutoComplete },
  data() {
    return {
      vehicleSelected: '',
      selectedVehicleObject: {},
    };
  },
  methods: {
    selectedTradeVehicle(vehicle) {
      this.selectedVehicleObject = vehicle;
      if (vehicle && vehicle.year) {
        this.submit();
      }
    },
    submit() {
      this.$store.commit('trade/SET_VEHICLE', this.selectedVehicleObject);
      this.$store.commit('trade/SET_LEAD_TRADEIN_VEHICLE');
      const location = {
        name: 'personal-info-form-desktop',
        params: {
          year: encodeURIComponent(this.selectedVehicleObject.year),
          make: encodeURIComponent(this.selectedVehicleObject.make),
          model: encodeURIComponent(this.selectedVehicleObject.model),
          trim: encodeURIComponent(this.selectedVehicleObject.trim) || 'no-trim',
          style: encodeURIComponent(this.selectedVehicleObject.style),
        },
      };
      this.$router.push(location);
    },
  },
  beforeRouteEnter: async (to, from, next) => {
    next(vm => {
      const tradeProvider = vm.$store.getters['business/getTradeInSource'];
      if (tradeProvider === TradeInSource.CARFAX) {
        const currentProduct = vm.$store.getters.getCurrentProduct;
        const path = vm.$store.getters.getProductHomeRoute(currentProduct);
        vm.$router.replace({ path, query: to.query, params: to.params });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 28px;
  font-weight: bold;
  margin-top: 56px;
}
.autocomplete-container {
  margin: 48px auto;
  max-width: 500px;
}
</style>
